import { render, staticRenderFns } from "./GCBOutflowHint.vue?vue&type=template&id=6326f556&scoped=true"
import script from "./GCBOutflowHint.vue?vue&type=script&lang=js"
export * from "./GCBOutflowHint.vue?vue&type=script&lang=js"
import style0 from "./GCBOutflowHint.vue?vue&type=style&index=0&id=6326f556&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326f556",
  null
  
)

export default component.exports